import React from "react";

/** Catalog prerequisite banner for the setup guide and dashboard card. */
export default function ProductSetupHint({ hint }) {
  if (!hint) return null;
  return (
    <div
      className={`setup-catalog-hint setup-catalog-hint--${hint.tone}`}
      role="status"
    >
      {hint.text}
    </div>
  );
}
